import React, { memo } from 'react'
import CompareVaccines from './CompareVaccines'
import { convertDatesToAP } from '../sfc/component-helpers/datehelpers'

const spanFunction = (word) => {
  // take word, return html of word wrapped in spans with classname using word

  return "<span class='" + word.toLowerCase() + "-legend'>" + word + '</span>'
}
const ClosestVaccines = ({ data, header, lastUpdated, descriptionRow }) => {
  const wordsToReplace = ['authorized', 'Authorized', 'others', 'Others']
  let htmlHeader = header
  for (let i = 0; i < wordsToReplace.length; i++) {
    htmlHeader = htmlHeader.replace(
      wordsToReplace[i],
      spanFunction(wordsToReplace[i])
    )
  }

  return (
    <section>
      <div className="container">
        <h2
          className="subhed"
          dangerouslySetInnerHTML={{ __html: htmlHeader }}
        ></h2>
        <p>
          The FDA has authorized {data.length} vaccines:{' '}
          {data.map((item, i) => {
            let isLast = i === data.length - 1
            let isFirst = i === 0

            return isLast
              ? ` and ${item.Company}.`
              : isFirst
              ? `${item.Company}`
              : `, ${item.Company}`
          })}{' '}
          Here's a breakdown of key facts about each.
        </p>
      </div>
      <CompareVaccines data={data} descriptionRow={descriptionRow} />
      <p class="footnote">Last updated: {convertDatesToAP(lastUpdated)}</p>
    </section>
  )
}

export default memo(ClosestVaccines)
